import { render, staticRenderFns } from "./fileConfigDialog.vue?vue&type=template&id=077e914c&"
import script from "./fileConfigDialog.vue?vue&type=script&lang=js&"
export * from "./fileConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports